import React, { Component } from 'react';
import { Navigate, NavLink } from 'react-router-dom';
import { UrlPaths } from '../../interfaces/UrlPaths/UrlPaths';
import ProgressBarProps from './ProgressBar.props';
import ProgressBarState from './ProgressBar.state';

export default class ProgressBar extends Component<ProgressBarProps, ProgressBarState> {
    constructor(props: ProgressBarProps) {
        super(props);
        this.state = {
            activeStep: this.props.activeStep,
        };

        this.clickOnStep = this.clickOnStep.bind(this);
    }

    componentDidMount(): void {
        const steps = document.querySelectorAll('.progress-bar__step')

        steps.forEach((item, index) => {
            if (index < this.state.activeStep) {
                item.addEventListener("click", () => this.clickOnStep(index));
            } else {
                item.classList.add('progress-bar__step--no-pointer');
            }
        });
    }

    clickOnStep(index: number) {
        if (this.state.activeStep > 0 && index < this.state.activeStep) {
            // Todo: go back one step after click
            // window.history.back()
            // window.history.back()
            if (index === 0) {
                console.log('index 0')
                return <Navigate to={UrlPaths.CARTPAGE} replace={true}/>
            } else if (index === 1) {
                return <Navigate to={UrlPaths.CUSTOMERDATAPAGE} replace={true}/>
            }
            
        }
        console.log('last page: ', );

        return '';
    }

    CreateStepButtonsWithOrWithoutRoute() {
        return this.props.steps.map((step, index) => {
            if (index < this.state.activeStep && index === 0) {
                return (
                    <NavLink to={UrlPaths.CARTPAGE} className={`progress-bar__step${index === this.state.activeStep
                        ? ' progress-bar__step--active'
                        : ''
                    }`}
                    key={index}>
                        <div className="progress-bar__counter"></div>
                        <div className="progress-bar__title">{step}</div>
                    </NavLink>
                )
            } else if (index < this.state.activeStep && index === 1) {
                return (
                    <NavLink to={UrlPaths.CUSTOMERDATAPAGE} className={`progress-bar__step${index === this.state.activeStep
                        ? ' progress-bar__step--active'
                        : ''
                    }`}
                    key={index}>
                        <div className="progress-bar__counter"></div>
                        <div className="progress-bar__title">{step}</div>
                    </NavLink>
                )
            } else {
                return (
                    <div className={`progress-bar__step${index === this.state.activeStep
                        ? ' progress-bar__step--active'
                        : ''
                    }`}
                    key={index}>
                        <div className="progress-bar__counter"></div>
                        <div className="progress-bar__title">{step}</div>
                    </div>
                )
            }
        });
    }

    render(): React.ReactNode {
        return (
            <>
                <div className={"progress-bar" + (this.props.noSticky ? "" : " progress-bar--sticky")}>
                    <div className="container progress-bar__container">
                        <div className="progress-bar__steps">
                            {this.CreateStepButtonsWithOrWithoutRoute()}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}